import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import {transferify} from 'shared/utils/data-service-utils';
import type {Rec} from 'typings/portaro.be.types';
import type {NewThreadMessageRequest, NewThreadRequest} from '../types';

export class ThreadsDataService {
    public static readonly serviceName = 'threadsDataService';

    public static readonly THREADS_ROUTE = 'threads';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async createNewThreadMessage(message: NewThreadMessageRequest): Promise<void> {
        return this.ajaxService
            .createRequest(`${ThreadsDataService.THREADS_ROUTE}/sent`)
            .post(transferify(message));
    }

    @ngAsync()
    public async createNewThread(thread: NewThreadRequest): Promise<Rec> {
        return this.ajaxService
            .createRequest(`${ThreadsDataService.THREADS_ROUTE}/create`)
            .post(transferify(thread));
    }

    @ngAsync()
    public async getUserThread(thread: NewThreadRequest): Promise<Rec[]> {
        return this.ajaxService
            .createRequest(`${ThreadsDataService.THREADS_ROUTE}`)
            .post(transferify(thread));
    }
}